/* ============================================================
   BUUB Bundle Builder
   - Shows floating bar when first item added to cart
   - Tracks cart item count
   - Updates tier highlights and progress bar
   - Applies discount tier messaging
   ============================================================ */

(function () {
  'use strict';

  var bar      = document.getElementById('bundle-bar');
  var fill     = document.getElementById('bundle-progress-fill');
  var label    = document.getElementById('bundle-progress-label');
  var closeBtn = document.getElementById('bundle-bar-close');
  var slots    = document.querySelectorAll('.bundle-item-slot');
  var tiers    = document.querySelectorAll('.bundle-tier');

  var TIERS = [
    { qty: 2, discount: 5  },
    { qty: 3, discount: 10 },
    { qty: 4, discount: 15 }
  ];

  var dismissed = false;

  /* --- Mini clearance sale (2026-08-13) -------------------------------
     Variants listed in data-tier-exclude-variants do NOT count toward the
     quantity tiers, and neither do free-gift lines. The Mini already carries
     the 30% clearance discount and the buy-2-get-2 bundle; promising it a
     further 5/10/15% would stack on protected margin.
     This changes the MESSAGING only — the bar has never applied a discount. --- */
  var EXCLUDED = ((bar && bar.dataset.tierExcludeVariants) || '')
    .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

  function isFreeGift(item) {
    return !!(item.properties && String(item.properties._free_gift) === 'true');
  }
  function countsForTier(item) {
    if (isFreeGift(item)) return false;
    return EXCLUDED.indexOf(String(item.variant_id)) === -1;
  }
  function tierCount(cart) {
    if (!cart.items) return 0;
    return cart.items.reduce(function (n, item) {
      return countsForTier(item) ? n + item.quantity : n;
    }, 0);
  }

  /* --- Fetch current cart --- */
  function fetchCart(cb) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () {});
  }

  /* --- Update UI based on cart --- */
  function updateBar(cart) {
    var count    = tierCount(cart);            // tier-eligible units only
    var anyItems = cart.item_count || 0;

    if (anyItems === 0 || dismissed) {
      bar.classList.remove('visible');
      return;
    }

    bar.classList.add('visible');

    /* Progress */
    var nextTier = TIERS.find(function (t) { return count < t.qty; });
    var topTier  = TIERS[TIERS.length - 1];

    if (nextTier) {
      var prev     = TIERS[TIERS.indexOf(nextTier) - 1];
      var from     = prev ? prev.qty : 0;
      var pct      = Math.min(((count - from) / (nextTier.qty - from)) * 100, 100);
      var needed   = nextTier.qty - count;
      fill.style.width  = pct + '%';
      label.textContent = 'Add ' + needed + ' more for ' + nextTier.discount + '% off';
    } else {
      fill.style.width  = '100%';
      label.textContent = topTier.discount + '% discount unlocked!';
    }

    /* Tier highlights */
    tiers.forEach(function (tier) {
      var qty = parseInt(tier.dataset.qty, 10);
      tier.classList.remove('active', 'unlocked');
      if (count >= qty) {
        tier.classList.add('unlocked');
      } else if (nextTier && qty === nextTier.qty) {
        tier.classList.add('active');
      }
    });

    /* Slots — only tier-eligible lines, so the bar stays coherent */
    var slotItems = (cart.items || []).filter(countsForTier);
    slots.forEach(function (slot, i) {
      var item = slotItems[i];
      slot.classList.remove('filled');
      slot.innerHTML = '';
      if (item) {
        slot.classList.add('filled');
        if (item.image) {
          var img   = document.createElement('img');
          img.src   = item.image;
          img.alt   = item.title;
          img.style.cssText = 'width:100%;height:100%;object-fit:contain;';
          slot.appendChild(img);
        } else {
          slot.textContent = item.title.slice(0, 2).toUpperCase();
        }
      }
    });
  }

  /* --- Intercept add-to-cart buttons --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quickshop-btn, .add-to-cart-btn, .product-card-btn');
    if (!btn) return;

    var variantId = btn.dataset.productId;
    if (!variantId) return;

    e.preventDefault();

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBar(cart);
        /* update cart badge count */
        var badge = document.querySelector('.cart-badge');
        if (badge) badge.textContent = cart.item_count;
      });
  });

  /* --- Close button --- */
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      dismissed = true;
      bar.classList.remove('visible');
    });
  }

  /* --- Init on load --- */
  fetchCart(updateBar);

})();
